/**
 * PackagesAdmin.tsx — Admin > Products > Packages.
 *
 * The corporate dashboard's Packages page for the signed-in account: package
 * templates (membership templates of increment type 2) with their
 * availability settings. See components/admin/MembershipTemplateAdmin.
 */
import { MembershipTemplateAdmin } from '@/components/admin/MembershipTemplateAdmin';

export function PackagesAdmin() {
  return <MembershipTemplateAdmin kind="package" />;
}
